import {AnyAction} from "redux";
import * as _ from "lodash";
import {CLEAR_SELECTED_LOCATION, SET_SELECTED_LOCATION} from "../actions/action";
import {getPowerSourceLocationsData, IPowerSource, IPowerSourceLocation} from "../../data/data";
import {createSelector} from "reselect";
import {getDraggingPowerSource} from "./draggingPowerSource";

//  define selectors

export const getSelectedLocation = state => state.location;
export const getLocationID = (state, props: number | { location_id: number }) => _.isNumber(props) ? props : _.get(props, 'location_id');


/**
 * get the data for the selected location
 */
export const getSelectedLocationData = createSelector(

    [getSelectedLocation],

    (location_id: number) : IPowerSourceLocation =>
    {
        const locations: IPowerSourceLocation[] = getPowerSourceLocationsData();

        // console.group('getSelectedLocationData')
        // console.log(locations);
        // console.log(location_id);
        // console.groupEnd();

        return locations[location_id];
    }
);


/**
 * check whether a location is suitable for the power source type being dragged
 */
export const isLocationValidForDraggingPowerSource = createSelector(

  [getDraggingPowerSource, getLocationID],

    (power_source: IPowerSource, location_id: number) =>
    {
        if (! _.isFinite(location_id) || location_id === -1) return false;

        //  find this power source's type

        const locations: IPowerSourceLocation[] = getPowerSourceLocationsData();
        const location: IPowerSourceLocation = locations[location_id];
        const type: string = location.type;

        //  check the type against the power source's approved list

        if (! power_source || ! power_source.requirements) return true;

        return _.includes(power_source.requirements, type);
    }
);


//  define the initial state

const initialState: number = 0;


/**
 * reducer: set the selected location
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function location(state: number = initialState, action: AnyAction) : number
{
    switch (action.type)
    {
        case SET_SELECTED_LOCATION:
        {
            const {payload} = action;
            const {location_id} = payload;

            return location_id;
        }

        case CLEAR_SELECTED_LOCATION:
        {
            return null;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/location.ts